<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
      class="member-name"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publish.by.member.consolidated.different.p1')}} <a
      class="consolidated-news"
      href="#"
      @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
    >{{news.textParams[2]}}
      {{$t('news.template.proposal.publish.by.member.consolidated.different.p2')}}</a>
    {{$t('news.template.proposal.publish.by.member.consolidated.different.p3')}}
    {{news.textParams[3]}}
    {{$t('news.template.proposal.publish.by.member.consolidated.different.p4')}}
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>
